import { useEffect, useState } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import * as fetchs from '../fetchs'
import * as lib from '../lib'
import * as state from '../states'
import {
	type ITokensState,
	type IFetchItems,
	type IFetchItemsSetup,
	type INoFetch,
	type TOfferSpendByAccount,
} from '../types'

type IUseOfferSpendByAccountList = {
	error: INoFetch | null;
	items: TOfferSpendByAccount[];
	total: number;
	warmUp: () => void;
}

export function useOfferSpendByAccountList(
	setup: IFetchItemsSetup,
	send: boolean
): IUseOfferSpendByAccountList {
	const tokens: ITokensState = useAtomValue(state.tokensAtom)
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)

	const [error, setError] = useState<INoFetch | null>(null)
	const [items, setItems] = useState<Array<TOfferSpendByAccount>>([])
	const [total, setTotal] = useState<number>(0)
	const [warmUpIt, setWarmUpIt] = useState<number>(0)
	const filter = lib.filterSetup([...setup?.filter ?? []])
	//console.log('useOfferSpendByAccountList:: ', { sort: setup?.sort })
	const sort = lib.sortSetup([...setup?.sort ?? []])
	const skip = lib.skipSetup(setup?.skip)
	const take = lib.takeSetup(setup?.take)
	const access = tokens?.access ?? null
	const warmUp = () => setWarmUpIt(warmUpIt + 1)

	useEffect(() => {
		const controller = new AbortController()
		const signal = controller.signal

		const call = async () => {
			try {
				setFetchIsLoading(state.turnOnLoader)
				const res = await fetchs.listOfferSpendByAccount(filter, sort, skip, take, signal, access)
				const { items, total }: IFetchItems<TOfferSpendByAccount> = res
				setError(null)
				setItems(items)
				setTotal(total)
			} catch (error: unknown) {
				setError(error as INoFetch)
				setItems([])
				setTotal(0)
			} finally {
				setFetchIsLoading(state.turnOffLoader)
			}
		}

		send && call()

		return () => {
			controller.abort()
		}
	}, [
		setFetchIsLoading,
		send,
		filter, sort,
		skip, take,
		access,
		warmUpIt
	])

	return { error, items, total, warmUp }
}
